import type { Fallacy } from "./types";
import { createStory } from "./types";

export const circularReasoning: Fallacy = {
    id: "circular-reasoning",
    name: "Circular Reasoning",
    emoji: "🔄",
    category: "Logika Rusak",
    description:
      "Kesimpulan digunakan sebagai premis, jadi argumennya **berputar-putar** tanpa **bukti baru**.",
    detail:
      "Circular Reasoning (Begging the Question) adalah kesalahan logika di mana **kesimpulan sudah diasumsikan benar di dalam premisnya sendiri**. Strukturnya: A benar karena B, B benar karena A — tidak ada bukti eksternal.\n\nKenapa ini fallacy? Karena argumen yang valid membutuhkan **bukti independen** — sesuatu di luar argumen itu sendiri. Argumen melingkar hanya mengulang klaim yang sama dengan kata-kata berbeda.\n\nCara mengenali: Tanyakan — apakah ada bukti di luar pernyataan itu sendiri? Kalau alasannya cuma mengulang klaimnya, itu circular.",
    tldr: "Alasannya cuma ngulang klaimnya sendiri? Muter-muter doang, Circular Reasoning.",
    story: createStory("Circular Reasoning", "🔄", {
      hook: {
        title: "Kamu nanya alasannya apa...",
        body: "Tapi jawabannya cuma **ngulang klaimnya sendiri** pake kata-kata beda. Muter-muter doang!",
      },
      convo: {
        claim: "Produk kami premium karena mahal, dan mahal karena premium. **Itu alasannya!**",
        response: "Itu cuma **ngulang klaim yang sama** pake kata beda. Mana bukti independennya?",
      },
      reveal: {
        body: "Kesimpulan dijadiin **premis**, premis dijadiin **kesimpulan**. A benar karena B, B benar karena A — **gak ada bukti baru**.",
      },
      insight: {
        title: "Cara ngeceknya?",
        body: "Tanya: ada bukti **di luar pernyataan itu sendiri** gak? Kalau jawabannya cuma ngulang klaim dengan kata beda — itu muter-muter.",
      },
      engagement: {
        title: "Pernah dapet jawaban yang muter-muter kayak gini?",
        body: "Dari sales, bos, atau politisi? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-authority", "false-dilemma", "appeal-to-nature"],
  };
